// import useLocalStorage, { deleteFromStorage } from "@rehooks/local-storage";
import { createContext, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useLocalStorage, { deleteFromStorage, writeStorage } from '@rehooks/local-storage'

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState({
    isLogin: useLocalStorage("isLogin")[0],
    user: useLocalStorage("user")[0],
  });
  const navigate = useNavigate();
  const location = useLocation();

  // let [isLogin] = useLocalStorage('isLogin')
  // let [user] = useLocalStorage('user')

  // Login updates the user data with a name parameter
  // The login function is updated
  // It now accepts a single 'user' object from the API response
  const login = (user) => {
    // 1. Explicitly write the session data to localStorage.
    writeStorage("user", user);
    writeStorage("token", user.accessToken); // Assumes the token is named accessToken in the user object
    writeStorage("isLogin", true);

    // Storing the complete user object in state and local storage
    setState({
      isLogin: true,
      user: user
    });

    // Perform the conditional redirect based on the isNewUser flag
    if (user && (user.isNewUser || !user.hasConsents)){
      navigate("/new-consent", { replace: true });
    } else {
      navigate("/home", { replace: true });
    }
  };

  // Logout updates the user data to default
  const logout = (currentPath) => {
    deleteFromStorage("isLogin");
    deleteFromStorage("user");
    deleteFromStorage("token");
    deleteFromStorage("portalRef");
    localStorage.removeItem("access_token");
    setState(null);
    // navigate('/', { replace: true })

    // Determine logout redirect based on current path
    let redirectPath = '/'
    
    if (currentPath && (currentPath.includes('/new-consent'))) {
      redirectPath = '/consent-login'
    } else if (currentPath && currentPath.includes('/manage-consent')) {
      redirectPath = '/consent-login'
    } else if (currentPath && currentPath.includes('/consent-login')) {
      redirectPath = '/consent-login'
    } else if (currentPath && currentPath.includes('/home')) {
      redirectPath = '/consent-login'
    } else if (currentPath && currentPath.includes('/faq')) {
      redirectPath = '/consent-login'
    } else if (currentPath && currentPath.includes('/manage-profile')) {
      redirectPath = '/consent-login'
    } 
    
    navigate(redirectPath, { replace: true })
  };
  // New function to update user data
  const updateUser = (updatedUserData) => {
    // Update both the React state and localStorage
    setState(prevState => ({ ...prevState, user: updatedUserData }));
    writeStorage("user", updatedUserData);
  };

  const value = {
    onLogin: login,
    onLogout: logout,
    onUpdateUser: updateUser // Include the new updateUser function in the context value
  }

  return (
    <AuthContext.Provider value={{ ...value, ...state }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
